export const Triangle: React.FC<React.SVGAttributes<SVGSVGElement>> = (
  props
) => (
  <svg
    viewBox='0 0 23 17'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path d='M.5 0h22l-11 17L.5 0z' fill='currentColor' />
  </svg>
);
